// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-popup[data-v-b35964bc]  .modal{padding:28px!important}.modal-result-popup[data-v-b35964bc]{padding:10px 0 21px}.modal-result-popup a[data-v-b35964bc],.modal-result-popup button[data-v-b35964bc]{margin-top:12px}h1[data-v-b35964bc]{font-weight:900;font-size:28px;line-height:38px}h1[data-v-b35964bc],h3[data-v-b35964bc]{width:100%;font-style:normal}h3[data-v-b35964bc]{font-weight:400;font-size:16px;line-height:22px}", ""]);
// Exports
module.exports = exports;
